import { Routes } from '@angular/router';

import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { managerGuard } from './guards/manager.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then((m) => m.Login),
  },
  {
    path: 'registrazione',
    loadComponent: () => import('./pages/registrazione/registrazione').then((m) => m.Registrazione),
  },
  {
    path: 'primo-login',
    loadComponent: () => import('./pages/primo-login/primo-login').then((m) => m.PrimoLogin),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
  },
  {
    path: 'media/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/media-detail/media-detail').then((m) => m.MediaDetail),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/profile/profile').then((m) => m.Profile),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password').then((m) => m.ForgotPassword),
  },
  {
    path: 'forgot-password-sent',
    loadComponent: () => import('./pages/forgot-password-sent/forgot-password-sent').then((m) => m.ForgotPasswordSent),
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password').then((m) => m.ResetPassword),
  },
  {
    path: 'reset-password-success',
    loadComponent: () => import('./pages/reset-password-success/reset-password-success').then((m) => m.ResetPasswordSuccess),
  },
  {
    path: 'admin/login',
    redirectTo: 'login',
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadComponent: () => import('./pages/admin/admin').then((m) => m.Admin),
  },
  {
    path: 'manager',
    canActivate: [managerGuard],
    loadComponent: () => import('./pages/manager/manager').then((m) => m.Manager),
  },
  {
    path: 'manager/users/:operatorId',
    canActivate: [managerGuard],
    loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
  },
  {
    path: 'manager/users/:operatorId/media/:id',
    canActivate: [managerGuard],
    loadComponent: () => import('./pages/media-detail/media-detail').then((m) => m.MediaDetail),
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
